const screenSizes = {
  smallDesktop: '1280px',
  tablet: '1024px',
  smallTablet: '768px',
  mobile: '460px',
  smallMobile: '360px',
};

export const white = '#FFFFFF';
export const codGray = '#191717';
export const azureRadiance = '#027FFD';

export default screenSizes;
